module.exports = __webpack_public_path__ + "static/media/20-11-14-1-resized-214x300.b74ac2f8.jpg";